<template>
    <div v-if="showBack" class="goback" @click="goback">
        <img class="location" src="@/assets/images/site/arrow_small.png" alt="">
        返回
    </div>
</template>

<script>
export default {
    data() {
        return {}
    },
    computed: {
        showBack() {
            let { query } = this.$route
            return !!Object.keys(query).length
        }
    },
    methods: {
        goback() {
            window.history.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>

.goback {
    position: absolute;
    z-index: 9;
    pointer-events: all;
    top: 200px;
    left: 300px;
    width: 100px;
    height: 50px;
    // border: 1px solid #1A7683;
    background: linear-gradient(180deg, rgba(14,134,139,0.88) 0%, rgba(0,43,41,0.6) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
    .location {
        width: 20px;
        height: 20px;
        margin-right: 15px;
        transform: rotate(180deg);
    }
}
</style>